module.exports = __webpack_public_path__ + "static/media/vscode.11c4184e.png";